export const SUBJECTS = {
  ADMIN_MARKUPS: 'Admin Markups',
  // -----------------
  VIEW_RECEIVING_RATES: 'View Receiving Rates',
  CREATE_RECEIVING_RATES: 'Create Receiving Rates',
  UPDATE_RECEIVING_RATES: 'Update Receiving Rates',
  DELETE_RECEIVING_RATES: 'Delete Receiving Rates',
  VIEW_MANIFEST_RATES: 'View Manifest Rates',
  CREATE_MANIFEST_RATES: 'Create Manifest Rates',
  UPDATE_MANIFEST_RATES: 'Update Manifest Rates',
  DELETE_MANIFEST_RATES: 'Delete Manifest Rates',

  WAREHOUSE_HOME: 'Warehouse Home',
  WAREHOUSE_DASHBOARD: 'Warehouse Dashboard',
  WAREHOUSE_ONHAND_DASHBOARD: 'Onhand Dashboard',
  WAREHOUSE_INBOUND_DASHBOARD: 'Inbound Dashboard',
  WAREHOUSE_OUTBOUND_DASHBOARD: 'Outbound Dashboard',
  WAREHOUSE_LOCATIONS: 'Warehouse Location',
  // WAREHOUSE_ADMIN_LINE_ITEMS: 'Admin Line Items',
  WAREHOUSE_LINE_ITEMS: 'Line Items',
  WAREHOUSE_ACCEPTANCE: 'Warehouse Acceptance',
  WAREHOUSE_RECEIVE_SHIPMENT: 'WarehouseReceiveShipment',
  WH_RECEIVE_VIEW_RECEIVE_BUTTON: 'WH - Receive View - Receive Button',
  WAREHOUSE_DISCREPANCY: 'Warehouse Discrepancy',
  ADMIN_WAREHOUSE_DISCREPANCY: 'Admin Warehouse Discrepancy',
  WAREHOUSE_CONSOLIDATION: 'Warehouse Consolidation',
  WAREHOUSE_MANIFEST_LEG: 'Warehouse Manifest Leg',
  WAREHOUSE_MANIFEST_LEG_AND_GATEWAY_SHIPMENT: 'ManifestLegAndGatewayShipment',
  WAREHOUSE_REPORTS: 'Warehouse Reports',
  CAN_ACCESS_ADMIN_APIS: 'CanAccessAdminAPIs',
  CAN_DOWNLOAD: 'CanDownload',
  CAN_READ_ACCOUNTS: 'CanReadAccounts',
  // NEW AND CONFIRMED ONES BELOW
  COMMENT: 'Comment',
  // WH - Admin Module
  WAREHOUSE_VEHICLE_TYPE: 'Warehouse Vehicle Type',
  WAREHOUSE_SUBCONTRACTOR: 'Warehouse Subcontractor',
  WAREHOUSE_FREIGHT_TYPE: 'Warehouse Freight Type',
  // WH - Item Module
  WAREHOUSE_ITEMS: 'Warehouse Items',
  WH_ITEM_DISCREPANCY: 'WH Item Discrepancy',
  WH_ITEM_HISTORY: 'WH - Item History',
  WH_ITEM_DOCUMENT: 'WH - Item Document',
  // WH - Manifest Module
  WAREHOUSE_MANIFEST: 'Warehouse Manifest',
  WH_MANIFEST_LEG: 'WH Manifest Leg',
  WH_MANIFEST_ITEMS: 'WH Manifest Items',
  WH_MANIFEST_CONSOL: 'WH Manifest Consolidations',
  WH_MANIFEST_DOCS: 'WH Manifest Docs',
  WH_MANIFEST_PAX: 'WH Manifest Passengers',
  // Metrics Module
  ADMIN_WAREHOUSE_METRICS_DAILY: 'WH - Metrics - Admin Daily Metric',
  WH_METRICS_MANIFEST_FREIGHT_MOVED: 'WH - Metrics - Freight Moved',
  // Carrier & Rate Sheet Module
  ADMIN_CARRIERS: 'Admin Carriers',
  ADMIN_CARRIERS_DISPATCHES: 'Admin Carrier Dispatches',
  ADMIN_CARRIERS_BOL: 'Admin Carrier Bill of Lading',
  ADMIN_CARRIERS_SERVICE: 'Admin Carrier Service',
  ADMIN_CARRIERS_CITY_ALIAS: 'Admin Carrier City Alias',
  ADMIN_CARRIERS_AIRBASE: 'Admin Airbase',
  ADMIN_FUEL_SURCHARGE: 'Admin Fuel Surcharge',
  ADMIN_RATE_SHEETS: 'Admin Ratesheets',
  ADMIN_SET_LANES: 'Admin Set Lanes',
  ADMIN_RATE_SHEET_COSTS: 'Admin Ratesheet Cost',
  ADMIN_SAILINGS: 'Admin Sailings',
  ADMIN_PORT: 'Admin Port',
  ADMIN_OPTIONS: 'Admin Options',
  ADMIN_MANDATORY_OPTIONS: 'Admin Mandatory Option',
  ADMIN_OPTIONAL_OPTIONS: 'Admin Optional Option',
  ADMIN_CN_ACCOUNT: 'Admin CN Account',
  ADMIN_CN_PD: 'Admin CN PD',
  ADMIN_CN_TRANSIT_TIME: 'Admin CN Transit Time',
  ADMIN_CN_NOG: 'Admin CN NOG',
  ADMIN_CN_INTERLINE: 'Admin CN Interline',
};
